export default __webpack_public_path__ + "media/zurb/img/icons/favicon/favicon-32x32-772c74e42fea7adb53b018be2fd16e30.png";